import {Component, Input, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {Asset, AssetService} from '@app/asset';
import {DownloadService} from '@app/download/download.service';
import {DeleteAssetDialogComponent} from '@app/shared/delete-asset-dialog/delete-asset-dialog.component';
import {User} from '@app/shared/user.service';
import {StateService} from '@app/state/state.service';
import {StreamService} from '@app/stream/stream.service';
import {filter, take} from 'rxjs/operators';
import {InspectorService} from '../inspector.service';

@Component({
    selector: 'frog-actions-inspector',
    templateUrl: './actions-inspector.component.html',
    styleUrls: ['./actions-inspector.component.scss'],
    imports: [MatButton],
})
export class ActionsInspectorComponent implements OnInit {
    @Input() asset: Asset;
    @Input() user: User;

    constructor(
        private assetService: AssetService,
        private streamService: StreamService,
        private stateService: StateService,
        private inspectorService: InspectorService,
        private downloadService: DownloadService,
        private matDialog: MatDialog,
    ) {}

    ngOnInit(): void {}

    like() {
        this.assetService.likeAsset(this.asset);
    }

    delete() {
        const dialog = this.matDialog.open(DeleteAssetDialogComponent, {
            width: '80vw',
            data: [this.asset],
        });
        dialog.afterClosed().subscribe((result) => {
            if (result === null) {
                return;
            }

            if (result === true) {
                // Remove from all
                this.assetService.deleteAssets([this.asset.id]);
                this.inspectorService.inspect(null);
            } else {
                // Remove form this stream
                this.stateService.state
                    .pipe(
                        filter((state) => Boolean(state.streamId)),
                        take(1),
                    )
                    .subscribe((state) => {
                        this.streamService.removeAssets(state.streamId, [this.asset.id]);
                        this.inspectorService.inspect(null);
                    });
            }
        });
    }

    download() {
        this.downloadService.downloadAssets([this.asset.id]);
    }
}
